'use client';
import React from 'react';
import MetricCard from '@/components/ui/MetricCard';
import { Flame, UtensilsCrossed, Package, Target } from 'lucide-react';
import { useSimulation } from '@/lib/simulationContext';

// 4 cards → 2×2 on md, 4-col on xl
export default function KPIBentoGrid() {
  const { simMode, kpi } = useSimulation();

  const streak = simMode ? `${kpi?.streak} days` : '14 days';
  const meals = simMode ? kpi?.mealsToday : '2 / 3';
  const pantry = simMode ? `${kpi?.pantryPct}%` : '23%';
  const accuracy = simMode ? `${kpi?.portionAccuracy}%` : '96.4%';

  return (
    <div data-component-id="src/app/components/KPIBentoGrid.tsx:17:4" data-component-path="src/app/components/KPIBentoGrid.tsx" data-component-line="17" data-component-end-line="50" data-component-file="KPIBentoGrid.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20xl%3Agrid-cols-4%202xl%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      <MetricCard data-component-id="src/app/components/KPIBentoGrid.tsx:18:6" data-component-path="src/app/components/KPIBentoGrid.tsx" data-component-line="18" data-component-end-line="25" data-component-file="KPIBentoGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%22%5Bvar%3Astreak%5D%22%7D"
        label="Feeding Streak"
        value={streak}
        subValue="Personal best: 21 days"
        icon={Flame}
        trend={{ value: '+2 from last week', positive: true }}
        variant="accent"
      />
      <MetricCard data-component-id="src/app/components/KPIBentoGrid.tsx:26:6" data-component-path="src/app/components/KPIBentoGrid.tsx" data-component-line="26" data-component-end-line="33" data-component-file="KPIBentoGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%22%5Bvar%3Ameals%5D%22%7D"
        label="Meals Today"
        value={meals}
        subValue="Next meal at 6:00 PM"
        icon={UtensilsCrossed}
        trend={{ value: 'On schedule', positive: true }}
        variant="positive"
      />
      <MetricCard data-component-id="src/app/components/KPIBentoGrid.tsx:34:6" data-component-path="src/app/components/KPIBentoGrid.tsx" data-component-line="34" data-component-end-line="41" data-component-file="KPIBentoGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%22%5Bvar%3Apantry%5D%22%7D"
        label="Pantry Level"
        value={pantry}
        subValue="≈ 4 days remaining"
        icon={Package}
        trend={{ value: 'Reorder soon', positive: false }}
        variant="warning"
      />
      <MetricCard data-component-id="src/app/components/KPIBentoGrid.tsx:42:6" data-component-path="src/app/components/KPIBentoGrid.tsx" data-component-line="42" data-component-end-line="49" data-component-file="KPIBentoGrid.tsx" data-component-name="MetricCard" data-component-content="%7B%22elementName%22%3A%22MetricCard%22%2C%22value%22%3A%22%5Bvar%3Aaccuracy%5D%22%7D"
        label="Portion Accuracy"
        value={accuracy}
        subValue="Avg vs AI recommendation"
        icon={Target}
        trend={{ value: '+1.2% this week', positive: true }}
        variant="default"
      />
    </div>
  );
}